<template>

<div class="main list-view no-sub-header">

	<div class="filters" v-if="showFilters">

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>

		<div class="divider"></div>

		<label>Tax / Fee Type</label>
		<select v-model="filters.applies_to" @change="getList()">
			<option value="">Select...</option>
			<option v-for="item in itemFees" :value="item.applies_to">{{ item.applies_to }}</option>
		</select>

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.not_charged ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_charged')"></span>
				<label>Show Exempted</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div v-if="orderDetail.order_id">
			<div class="button neutral" @click="orderDetail = {}">Back To Report</div>
		</div>
		<div v-else>
			<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
			<div class="divider"></div>
			<div :class="['extra-menu-item', gettingExport ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>

	</div>

	<div v-if="orderDetail.order_id" class="detail">

		<div v-if="loading" class="loading empty-list"><i class="fa fa-spinner fa-spin" /></div>
		<order-detail v-else :orderDetail="orderDetail" />

	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>

			<div class="printable-heading">Other Taxes / Fees: {{ filters.start_date }} through {{ filters.end_date }}</div>

			<div class="sub-header" style="grid-template-columns: 1fr 1fr;">
				<div class="four-columns" style="padding: 0 0 0 1em;">
					<div>
						<label>Item Price Total</label><br><b>{{ $formatCurrency(reportTotalItems) }}</b>
					</div>
					<div>
						<label>Non-Item Total</label><br><b>{{ $formatCurrency(reportNonItemTotal) }}</b>
					</div>
					<div>
						<label>Transfer Total</label><br><b>{{ $formatCurrency(reportTransferTotal) }}</b>
					</div>
					<div>
						<label>Tax / Fee Total</label><br><b>{{ $formatCurrency(reportTotal) }}</b>
					</div>
				</div>
				<div class="controls">
					<pagination :paging="paging" @updatePage="goToPage"></pagination>
				</div>
			</div>

			<table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list">Date</th>
						<th class="list">Order #</th>
						<th class="list left">Description</th>
						<!-- <th class="list left">Item UPC</th> -->
						<th class="list left">Item Description / UPC</th>
						<th class="list right">Item<br>Price</th>
						<th class="list right">Tax / Fee<br>Amount</th>
					</tr>
				</thead>
				<tr v-for="item in list" class="clickable-list-item" @click="getOrder(item.order_id)">
					<td class="list left">{{ item.order_date }}</td>
					<td class="list left">{{ item.order_number }}</td>
					<td class="list left">{{ item.description }}</td>
					<!-- <td class="list left"></td> -->
					<td class="list left">{{ item.product_description }}<br>{{ item.upc }}</td>
					<td class="list right">{{ item.order_price }}</td>
					<td class="list right">{{ item.amount }}</td>
				</tr>
			</table>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import OrderDetail from '@/components/OrderDetail.vue'
export default {
	name: 'order-item-fees',
    components: {
        'order-detail': OrderDetail
    },
	data() {
		return {
            loading: true,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
			itemFees: [],
            default_start_date: '',
            default_end_date: '',
			list: [],
			reportTotal: 0,
			reportTotalItems: 0,
            reportNonItemTotal: 0,
            reportTransferTotal: 0,
			paging: {},
			orderDetail: {},
			gettingExport: false
		}
	},
	created() {
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: '',
				applies_to: '',
				not_charged: false,
				do_export: false
			}

			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)

			this.filters.start_date = this.$route.query.start || this.default_start_date
			this.filters.end_date = this.$route.query.end || this.default_end_date

			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getTotals() {
			// copy filters to totalsFilters
			let totalsFilters = JSON.parse(JSON.stringify(this.filters))
			totalsFilters.totals_only = true
			this.apiCall({ destination: 'get_report_order_item_fees', data: totalsFilters }).then(obj => {
				this.reportTotal = obj.total
				this.reportTotalItems = obj.item_total
                this.reportNonItemTotal = obj.non_item_total
                this.reportTransferTotal = obj.transfer_total
				this.itemFees = obj.item_fees
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			this.getTotals()
			this.orderDetail = {}
			this.loading = true
			this.message = 'Generating report...'
			this.apiCall({ destination: 'get_report_order_item_fees', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					this.message = 'Downloading CSV...'
					document.getElementById("download").src = obj.download_url
					setTimeout(() => {
						this.gettingExport = false
						this.message = ''
					}, 1000)
				} else {
					this.list = obj.list
					this.paging = obj.paging
					this.message = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getOrder(orderId) {
			if (this.loading || !orderId) { return }
			this.loading = true
			this.orderDetail = { order_id: orderId }
			this.apiCall({ destination: 'get_item_order', data: { order_id: orderId } }).then(obj => {
				this.orderDetail.order = obj.order_detail
				this.orderDetail.billing = obj.order_billing_address
				this.orderDetail.custom_fields = obj.order_billing_custom_fields
				this.orderDetail.shipping = obj.order_shipping_address
				this.orderDetail.items = obj.order_items
				this.orderDetail.discounts = obj.order_discounts
				this.orderDetail.fees = obj.order_fees
				this.orderDetail.item_fees = obj.order_item_fees
				this.orderDetail.payments = obj.order_payments
				this.orderDetail.totals = obj.order_totals
				this.loading = false
			})
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.message = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList(1)
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		}
	}
}
</script>
